/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { useState, createContext } from 'react';
import { DragDropContext } from 'react-beautiful-dnd'; // export interface EuiDragDropContextProps extends DragDropContextProps {}

export var EuiDragDropContextContext = /*#__PURE__*/createContext({
  isDraggingType: null
});
export var EuiDragDropContext = ({
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  children,
  ...rest
}) => {
  const [isDraggingType, setIsDraggingType] = useState(null);

  const euiOnDragStart = (start, provided) => {
    setIsDraggingType(start.type);

    if (onDragStart) {
      onDragStart(start, provided);
    }
  };

  const euiOnDragEnd = (result, provided) => {
    setIsDraggingType(null);

    if (onDragEnd) {
      onDragEnd(result, provided);
    }
  };

  return <DragDropContext onBeforeDragStart={onBeforeDragStart} onDragStart={euiOnDragStart} onDragUpdate={onDragUpdate} onDragEnd={euiOnDragEnd} {...rest}>
      <EuiDragDropContextContext.Provider value={{
      isDraggingType
    }}>
        {children}
      </EuiDragDropContextContext.Provider>
    </DragDropContext>;
};

try {
  EuiDragDropContext.__docgenInfo = {
    description: '',
    displayName: 'EuiDragDropContext',
    methods: [],
    props: {
      onBeforeCapture: {
        defaultValue: null,
        description: '',
        name: 'onBeforeCapture',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: '(before: BeforeCapture) => void'
        }
      },
      onBeforeDragStart: {
        defaultValue: null,
        description: '',
        name: 'onBeforeDragStart',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: '(initial: DragStart) => void'
        }
      },
      onDragStart: {
        defaultValue: null,
        description: '',
        name: 'onDragStart',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: '(initial: DragStart, provided: ResponderProvided) => void'
        }
      },
      onDragUpdate: {
        defaultValue: null,
        description: '',
        name: 'onDragUpdate',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: '(initial: DragUpdate, provided: ResponderProvided) => void'
        }
      },
      onDragEnd: {
        defaultValue: null,
        description: '',
        name: 'onDragEnd',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: true,
        type: {
          name: '(result: DropResult, provided: ResponderProvided) => void'
        }
      },
      dragHandleUsageInstructions: {
        defaultValue: null,
        description: '',
        name: 'dragHandleUsageInstructions',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      nonce: {
        defaultValue: null,
        description: '',
        name: 'nonce',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      enableDefaultSensors: {
        defaultValue: null,
        description: '',
        name: 'enableDefaultSensors',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: 'boolean'
        }
      },
      sensors: {
        defaultValue: null,
        description: '',
        name: 'sensors',
        parent: {
          fileName: 'eui-docs_master/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        required: false,
        type: {
          name: 'Sensor[]'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}